export const SPOT_FIELDS = [
  'Symbol',
  'Status',
  'Code',
  'TimeRef',
  'PeriodType',
  'Period',
  'Alias',
  'Title',
  'AdditionalItem',
  'LastDate',
  'Last',
  'Change',
  'Currency',
  'Units',
  'Commodity',
  'TradingHub',
  'DeliveryBasis',
  'PricingBasis',
  'Frequency',
  'IndexModule',
  'PeriodAbs',
  'StartDate',
  'EndDate',
  'LaunchDate',
  'FactsheetVersion',
  'TimeZone',
  'HolidayCalendar',
  'LastTradeDateCalendar',
  'Increment',
  'Index',
  'Factsheet'
] as const;

export const FORWARD_CURVE_FIELDS = [
  'Symbol',
  'Status',
  'Code',
  'TimeRef',
  'PeriodType',
  'Periods',
  'Title',
  'Currency',
  'Units',
  'Commodity',
  'TradingHub',
  'DeliveryBasis',
  'PricingBasis',
  'Frequency',
  'IndexModule',
  'StartDate',
  'EndDate',
  'LaunchDate',
  'FactsheetVersion',
  'TimeZone',
  'HolidayCalendar',
  'LastTradeDateCalendar',
  'Increment',
  'Index',
  'Factsheet',
  'PeriodMin',
  'PeriodMax'
] as const;
